import Vue from 'vue'
import VueRouter from 'vue-router'
import Profile from '../views/profile/index.vue'
import Admin from '../views/admin/index.vue'
import CenterAdmin from '../views/center-admin/index.vue'
import Users from '../views/users/index.vue'
import User from '../views/user/index.vue'
import Centers from '../views/centers/index.vue'
import Center from '../views/center/index.vue'


import {
  authGuard
} from '../auth/authGuard'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  component: () => import('@/layouts/home/Index.vue'),
  children: [{
      path: '',
      name: 'Forside',
      component: () => import('@/views/home/Index.vue'),
    },
    {
      path: 'booking',
      name: 'Kalender',
      beforeEnter: authGuard,
      component: () => import('@/views/booking/Index.vue'),
      meta: {
        src: require('@/assets/about.jpg')
      },
    },
    {
      path: 'shop',
      name: 'Shop',
      beforeEnter: authGuard,
      component: () => import('@/views/shop/Index.vue'),
      meta: {
        src: require('@/assets/about.jpg')
      },
    },
    {
      path: 'contact-us',
      name: 'Kontakt',
      component: () => import('@/views/contact-us/Index.vue'),
      meta: {
        src: require('@/assets/contact.jpg')
      },
    },
    {
      path: 'pro',
      name: 'Pro',
      component: () => import('@/views/pro/Index.vue'),
      meta: {
        src: require('@/assets/pro.jpg')
      },
    },
    {
      path: 'profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: authGuard
    },
    {
      path: 'admin',
      name: 'Admin',
      component: Admin,
      beforeEnter: authGuard
    },
    {
      path: 'center-admin',
      name: 'CenterAdmin',
      component: CenterAdmin,
      beforeEnter: authGuard
    },
    {
      path: 'centers',
      name: 'Centers',
      component: Centers,
      beforeEnter: authGuard
    },
    {
      path: 'center/:id',
      name: 'Center',
      component: Center,
      beforeEnter: authGuard
    },

    {
      path: 'users',
      name: 'Users',
      component: Users,
      beforeEnter: authGuard
    },
    {
      path: 'user/:id',
      name: 'User',
      component: User,
      beforeEnter: authGuard
    },
    {
      path: '*',
      name: 'FourOhFour',
      component: () => import('@/views/404/Index.vue'),
    },
  ],
}];





const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



export default router